import type { ICompanyIssuer } from "types/graphqlTypes";
import { IPlatformVertical } from "types/graphqlTypes";

export default function getCompanyIssuerLinkProps(issuer: Pick<ICompanyIssuer, "vertical" | "tickerSymbol">) {
  const tickerSymbol = issuer.tickerSymbol.toLowerCase();
  if (issuer.vertical === IPlatformVertical.Stocks || issuer.vertical === IPlatformVertical.Reits) {
    return {
      href: "/us/[tickerSymbol]",
      as: `/us/${tickerSymbol}`,
    };
  }
  if (issuer.vertical === IPlatformVertical.Fiis) {
    return {
      href: "/fiis/[tickerSymbol]",
      as: `/fiis/${tickerSymbol}`,
    };
  }
  if (issuer.vertical === IPlatformVertical.Acoes) {
    return {
      href: "/br/[tickerSymbol]",
      as: `/br/${tickerSymbol}`,
    };
  }
  throw new Error("Not supported yet");
}
